import { PAYMENT_OPTIONS } from '@/constants/payment';
import { getCards } from '@/services/payment.service';

export const CardModule = {
    state: () => ({
        cards: [],
    }),
    mutations: {
        setCards(state, data) {
            state.cards = data;
        },
    },
    actions: {
        async fetchCards({ commit }) {
            try {
                if (
                    PAYMENT_OPTIONS.PAY_WAY_PLUS.isEnable ||
                    PAYMENT_OPTIONS.OMISE.isEnable
                ) {
                    const { data } = await getCards();
                    commit('setCards', data);
                }
            } catch (e) {
                commit('setCards', []);
            }
        },
    },
    namespaced: true,
};
